


const BlogPageHero = () =>{
    return (
        <section className=" bg-gradient-to-r from-blue-100 to-cyan-300 h-[70vh] flex items-center justify-center mt-2 max-sm:p-2 max-sm:pb-8">
                <h2 className="text-4xl sm:text-6xl font-serif sm:w-[70%] text-center leading-loose max-sm:leading-[70px]">Personalised pre-sorted medicines at your doorstep</h2>
        </section>
    )
}
 
export default BlogPageHero; 